/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectsCloneMutationRequest, ProjectsCloneMutationResponse, ProjectsClonePathParams } from "../models/ProjectsClone";

export function getProjectsCloneUrl(id: ProjectsClonePathParams["id"]) {
  const res = { method: 'POST', url: `/projects/${id}/clone` as const }  
  return res
}

/**
 * @summary Clone a project (requires new name)
 * {@link /projects/:id/clone}
 */
export async function projectsClone(id: ProjectsClonePathParams["id"], data: ProjectsCloneMutationRequest, config: Partial<RequestConfig<ProjectsCloneMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectsCloneMutationResponse, ResponseErrorConfig<Error>, ProjectsCloneMutationRequest>({ method : "POST", url : getProjectsCloneUrl(id).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}